module.exports = __webpack_public_path__ + "media/25 strike a chord within with sb.91e5fb8b.mp3";